import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [ReactiveFormsModule, MatIcon, MatInputModule, MatButtonModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})
export class SearchComponent {
  @Output() searched = new EventEmitter<string | null>();

  searchControl: FormControl<string | null> = new FormControl('');

  onSearch(): void {
    this.searched.emit(this.searchControl.value);
  }
}
